import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

import { ProjectManagerService } from './project-manager.service';
import { element } from 'protractor';
import {val} from "@uirouter/angular";
import { MODERN_DEFAULT_SPAN } from '../models/2d3d/modern.config';

@Injectable()
export class DataForDisplayingMenuItemsService {
  railingType = new BehaviorSubject<string>('');
  postMounting = new BehaviorSubject<string>('');
  cornerPosts = new BehaviorSubject<string>('');
  railingHeight = new BehaviorSubject<string>('');
  // Modern kit section span in feet ('6' | '8'); 8 ft only at 36" height
  sectionSpan = new BehaviorSubject<string>(MODERN_DEFAULT_SPAN);
  topRail = new BehaviorSubject<string>('');
  topRailForStairs = new BehaviorSubject<string>('');
  infill = new BehaviorSubject<string>('');
  stairHandrail = new BehaviorSubject<string>('');
  lightingBSubj = new BehaviorSubject<object>({});
  railingColors = new BehaviorSubject<object>({});
  projectColorsBSubj = new BehaviorSubject<any>({});
  setDefaultColorsByRailingType = new Subject<any>();
  setStep = new Subject<any>();
  startNewProj = new Subject<void>();
  proToolsResetProj = new BehaviorSubject<string>(null);
  currentStep: number = 1;
  firstStepChange = new Subject<boolean>();
  needRailingRebuild = new Subject<void>();
  needRailingRebuildIfVisible = new Subject<void>();
  needStairRemove = new Subject<any>();
  needRailingRebuildForHandrail = new Subject<void>();
  currentChoises: any;
  currentColors: any = {};
  changeSelectedMenuItem = new Subject<string>();
  postCapsVisible = new Subject<boolean>();
  verticalPicketUpdated = new Subject<any>();
  infillStSteelPicketsUpdated = new Subject<any>();

  constructor(private projectSrvc: ProjectManagerService) {
    this.setDefaultParams();
  }

  setProToolsResetProj() {
    // FR-1021
    const projKey = btoa(Math.random().toString()).substr(10, 5);
    this.proToolsResetProj.next(projKey);
  }

  setRailingType(value: string, notUpdateRail?: boolean) {
    this.currentChoises.railingType = value;
    // this.currentChoises.railingColors = '';
    let stairHandrail = '';
      if (value === 'DesignRail' && this.projectSrvc.getProjectType() === 'business') {
        stairHandrail = 'appliedHandrail';
      } else if (value === 'DesignRail') {
        stairHandrail = 'top150';
      }
    // this.currentChoises.stairHandrail = value==="DesignRail"?  this.currentChoises.stairHandrail: '';
    this.setStairHandrail(stairHandrail, false);
    this.railingType.next(value);
    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setPostMounting(value: string, notUpdateRail?: boolean) {
    if (
      (this.currentChoises.railingType === 'Steel round tubular' ||
        this.currentChoises.railingType === 'Wood' ||
        this.currentChoises.railingType === 'DesignRail') &&
      this.currentChoises.cornerPosts === 'Single' &&
      value === 'Fascia Mount'
    ) {
      this.setCornerPosts('Double', true);
    }
    this.currentChoises.postMounting = value;
    this.postMounting.next(value);
    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setCornerPosts(value: string, notUpdateRail?: boolean) {
    this.currentChoises.cornerPosts = value;
    this.cornerPosts.next(value);
    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setRailingHeight(value: string, notUpdateRail?: boolean) {
    this.currentChoises.railingHeight = value;
    this.railingHeight.next(value);
    this.currentChoises.railingHeightForStairs = value;

    // Modern kits: 8 ft sections exist only for 36" height (spec p.2 rule 1)
    if (value !== '36' && this.currentChoises.sectionSpan === '8') {
      this.setSectionSpan(MODERN_DEFAULT_SPAN, true);
    }

    if (value === '36' && this.currentChoises.stairHandrail === 'appliedHandrail') {
      this.setStairHandrail('', true);
    }

    if (this.currentChoises.topRail === '150s' && value === '38') {
      this.setStairHandrail('top150', true);
    }

    if (this.currentChoises.stairHandrail === 'top150' && value !== '36') {
      this.currentChoises.railingHeightForStairs = '36';
    }

    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setSectionSpan(value: string, notUpdateRail?: boolean) {
    this.currentChoises.sectionSpan = value;
    this.sectionSpan.next(value);
    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setTopRail(value: string, notUpdateRail?: boolean) {
    this.currentChoises.topRail = value;
    this.topRail.next(value);

    if (this.currentChoises.stairHandrail === 'top150') {
      this.currentChoises.topRailForStairs = '150s';
    } else {
      this.currentChoises.topRailForStairs = value;
    }

    if (
      value === '150s' &&
      (this.currentChoises.railingHeight === '38' || this.currentChoises.railingHeight === '36')
    ) {
      this.setStairHandrail('top150', true);
    }

    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setInfill(value: string, notUpdateRail?: boolean) {
    this.currentChoises.infill = value;
    this.infill.next(value);
    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setRailOptions(value, status) {
    this.currentChoises[value] = status;
  }

  getRailOptions(value) {
    return this.currentChoises[value];
  }

  setVerticalPicket(shapeType: string, colorName: string, notUpdateRail?: boolean) {
    this.currentChoises.verticalPicketShapeType = shapeType;
    this.currentChoises.verticalPicketColorName = colorName;
    this.verticalPicketUpdated.next();
    if (!notUpdateRail) {
      this.needRailingRebuild.next();
    }
  }

  setStairHandrail(value: string, notUpdateRail?: boolean) {
    let remove: boolean = this.currentChoises.stairHandrail && !value ? true : false;
    this.currentChoises.stairHandrail = value;
    if (value === 'top150') {
      this.currentChoises.railingHeightForStairs = '36';
      this.currentChoises.topRailForStairs = '150s';
    } else {
      this.currentChoises.railingHeightForStairs = this.currentChoises.railingHeight;
      this.currentChoises.topRailForStairs = this.currentChoises.topRail;
    }
    this.stairHandrail.next(value);
    if ((!notUpdateRail && this.currentChoises.stairHandrail) || remove) {
      this.needRailingRebuildForHandrail.next();
    }
  }

  // to do
  // maybe not needed
  setLighting(lighting: any) {
    this.currentChoises.lighting = { ...this.currentChoises.lighting, ...lighting };
  }

  setRailingColor(color: any) {
    // http://146.185.164.175:8080/browse/FR-978
    let railingColor = this.currentChoises.railingColors.find(rc => rc.type === color.type);
    if (railingColor) {
      railingColor = { ...railingColor, ...color };
    } else {
      this.currentChoises.railingColors.push(color);
    }
  }

  getCurrentParams() {
    return this.currentChoises;
  }

  setCurrentParams(railingParams) {
    this.currentChoises.railingType = railingParams.railingType;
    this.railingType.next(railingParams.railingType);

    this.currentChoises.postMounting = railingParams.postMounting;
    this.postMounting.next(railingParams.postMounting);

    this.currentChoises.cornerPosts = railingParams.cornerPosts;
    this.cornerPosts.next(railingParams.cornerPosts);

    this.currentChoises.railingHeight = railingParams.railingHeight;
    this.railingHeight.next(railingParams.railingHeight);

    // older saves have no sectionSpan — default to the 6 ft kit; re-apply the
    // 36"-only rule for the 8 ft kit too (spec p.2 rule 1) in case the saved
    // combination predates it or was edited by hand
    this.currentChoises.sectionSpan =
      railingParams.railingHeight === '36'
        ? railingParams.sectionSpan || MODERN_DEFAULT_SPAN
        : MODERN_DEFAULT_SPAN;
    this.sectionSpan.next(this.currentChoises.sectionSpan);

    this.currentChoises.infill = railingParams.infill;
    this.infill.next(railingParams.infill);

    this.currentChoises.stairHandrail = railingParams.stairHandrail;
    this.stairHandrail.next(railingParams.stairHandrail);

    // this.currentChoises.lighting = railingParams.lighting;
    // this.currentChoises.railingColors = railingParams.railingColors;
    this.currentChoises.toggleRailing = railingParams.toggleRailing;

    this.currentChoises.topRailForStairs = railingParams.topRailForStairs;
    this.topRailForStairs.next(railingParams.topRailForStairs);

    this.currentChoises.topRail = railingParams.topRail;
    this.topRail.next(railingParams.topRail);
  }

  setDefaultParams(): void {
    if (this.projectSrvc.getProjectType() === 'dock') {
      // DockRail mode: single fixed configuration (36" fascia, cable, no stairs)
      this.currentChoises = {
        railingType: 'DockRail',
        postMounting: 'Fascia Mount',
        cornerPosts: 'Single',
        railingHeight: '36',
        topRail: '200s',
        topRailForStairs: '',
        infill: 'horizontalCable',
        stairHandrail: '',
        lighting: {},
        railingColors: [],
        railingHeightForStairs: '',
        basePlateCovers: false,
        infillStandartCablerailKits: true,
        sectionSpan: MODERN_DEFAULT_SPAN,
      };
      this.railingType.next('DockRail');
      this.postMounting.next('Fascia Mount');
      this.cornerPosts.next('Single');
      this.railingHeight.next('36');
      this.topRail.next('200s');
      this.infill.next('horizontalCable');
      this.setStairHandrail('', true);
      this.postCapsVisible.next(false);
      return;
    }
    this.currentChoises = {
      railingType: 'DesignRail',
      postMounting: 'Base Mount',
      cornerPosts: 'Single',
      railingHeight: '36',
      topRail: '200s',
      topRailForStairs: '150s',
      infill: 'horizontalCableBaserail',
      stairHandrail: 'top150',
      lighting: {},
      railingColors: [],
      railingHeightForStairs: '',
      basePlateCovers: true,
      infillStandartCablerailKits: true,
      sectionSpan: MODERN_DEFAULT_SPAN,
    };
    this.railingType.next('DesignRail');
    this.postMounting.next('Base Mount');
    this.cornerPosts.next('Single');
    this.projectSrvc.getProjectType() === 'business'
      ? this.railingHeight.next('36')
      : this.railingHeight.next('42');
    this.topRail.next('200s');
    this.infill.next('horizontalCableBaserail');
    const stairHandrail = this.projectSrvc.getProjectType() === 'business' ? 'appliedHandrail' : 'top150';
    this.setStairHandrail(stairHandrail, true);
    this.postCapsVisible.next(true);
    this.currentChoises.verticalPicketShapeType = 'Square';
    this.currentChoises.verticalPicketColorName = 'Black';
  }

  setCurrentStep(step: number) {
    this.currentStep = step;
    this.setStep.next(step);
  }

  startNewProject() {
    this.setDefaultParams();
    this.setCurrentStep(1);
    this.startNewProj.next();
    this.firstStepChange.next(true);
  }

  getCurrentStep() {
    return this.currentStep;
  }

  getRailingCurrentColor(type) {
    return this.currentColors[type].railingElements;
  }

  updateColorMap(colorMap) {
    this.currentColors = colorMap;
  }

  projectColorsExist(project?) {
    project = project || this.projectSrvc.project;
    return (
      project &&
      project.railing &&
      project.railing.railingColors &&
      Array.isArray(project.railing.railingColors) &&
      project.railing.railingColors.length
    );
  }

  setProjectColors(project?): void {
    project = project || this.projectSrvc.project;
    // http://146.185.164.175:8080/browse/FR-978
    this.projectColorsBSubj.next(project.railing.railingColors);
  }

  setProjectLighting(): void {
    let lighting = { topRailLights: false, bottomRailLights: false, postAccentLights: false };
    if (
      this.projectSrvc.project &&
      this.projectSrvc.project.railing &&
      this.projectSrvc.project.railing.lighting
    ) {
      lighting = { ...lighting, ...this.projectSrvc.project.railing.lighting };
    }
    this.lightingBSubj.next(lighting);
  }

  setDeafaultColors(): void {
    const railingColors = Object.values(
      this.currentColors[this.currentChoises.railingType].railingElements
    ).reduce((acc: any, item: any) => {
      if (
        item.type === 'Picket' ||
        item.type === this.currentChoises.infill ||
        item.type === 'Post' ||
        item.type === 'Top Rail' ||
        item.type === 'Bottom Rail' ||
        item.type === 'Top Cap'
      ) {
        item.selected = item.colors.find(c => c.name === item.defaults);
        acc.push(item);
      }
      return acc;
    }, []);
    this.projectColorsBSubj.next(railingColors);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data-for-displaying-menu-items.service.ts